module.exports = __webpack_public_path__ + "static/images/user-add.e48d311446228723452f8fc2c202047a.svg";